'use strict';

var dateFns = require('date-fns');
var parseISOTimeIntervalToMilliseconds = require('./parseISOTimeIntervalToMilliseconds.cjs');

const parseISOTimeIntervalToHours = (unorderedInterval) => {
  const intervalInMilliseconds = parseISOTimeIntervalToMilliseconds(unorderedInterval);
  return dateFns.millisecondsToHours(intervalInMilliseconds);
};

module.exports = parseISOTimeIntervalToHours;
//# sourceMappingURL=parseISOTimeIntervalToHours.cjs.map
